import { Component, OnInit, Inject, PLATFORM_ID, Renderer2, AfterViewInit, OnDestroy } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../../_services/langhfre.service';

@Component({
  selector: 'app-yonsei-university',
  templateUrl: './yonsei-university.component.html',
  styleUrls: ['./yonsei-university.component.scss']
})
export class YonseiUniversityComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private linkService: LinkService,
    private renderer: Renderer2
  ) { }

  ngOnInit() {
    this.titleService.setTitle('연세대대학교 소속원 전용 AI 문법 검사기 |트링카');
    this.metaTagService.updateTag({ name: 'description', content: '트링카는 이나고 자사 브랜드의 AI 문법 검사기입니다. 연세대대학교와의 파트너십을 통해 학술 및 기술 글작성 스킬을 향상시켜 보세요' });
    this.metaTagService.updateTag({ property: 'og:title', content: '연세대대학교 소속원 전용 AI 문법 검사기 |트링카' });
    this.metaTagService.updateTag({ property: 'og:description', content: '트링카는 이나고 자사 브랜드의 AI 문법 검사기입니다. 연세대대학교와의 파트너십을 통해 학술 및 기술 글작성 스킬을 향상시켜 보세요' });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/university/yonsei-university' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '연세대대학교 소속원 전용 AI 문법 검사기 |트링카' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "트링카는 이나고 자사 브랜드의 AI 문법 검사기입니다. 연세대대학교와의 파트너십을 통해 학술 및 기술 글작성 스킬을 향상시켜 보세요" });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/Trinka.jpg' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.linkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/university/yonsei-university' });
    this.linkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/kr/university/yonsei-university' });
    this.linkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/university/yonsei-university' });
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      const header = document.querySelector('app-header');
      const footer = document.querySelector('app-footer');

      if (header) {
        this.renderer.setStyle(header, 'display', 'none');
      }

      if (footer) {
        this.renderer.setStyle(footer, 'display', 'none');
      }
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
      const header = document.querySelector('app-header');
      const footer = document.querySelector('app-footer');

      if (header) {
        this.renderer.removeStyle(header, 'display');
      }

      if (footer) {
        this.renderer.removeStyle(footer, 'display');
      }
    }
  }
}
